export default class SerialNumber {
  start = 0
  end = 0

  constructor(obj: unknown) {
    Object.assign(this, obj)
  }

  get quantity(): number {
    return this.end - this.start + 1
  }

  get toString(): string {
    return `${this.start} - ${this.end}`
  }
}
